<template>
    <div>

 <div class="row">
      <div class="col-md-12">
        <div class="panal mt-20">
           <div class="panal-header">Send to Adviser</div>
          <div class="panal-body">
           
          <b-alert show>
                 <h1>Nice message Title</h1>
                 <h6>Sub Title </h6>
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                    when an unknown printer took a galley of type and scrambled it to make a type specimen book. 
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a 
                    galley of type and scrambled it to make a type specimen book.
          </b-alert>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>





</div>
</template>


<script>
    export default {
        name: 'SendtoAdviser',
        data() {
          
      return {
        deleteClicked: false,
        change: false,
        selected2: null,
        selected: null,
        options: [
          { value: null,text:'Please select an option'},
          { value: 'A', text: 'This is First option'},
          { value: 'B', text: 'This is scond option'},
          { value: 'C', text: 'This is third option'},
        
        ],
        
      } 
      
    },
  methods:{
     onClick() {
      this.deleteClicked = true;
    },
        ok()
        {
         this.change = true;
        }
            }

    };
</script>







<style >
h1{
    color: #285475;
    font-size: 25px;
    border-bottom: 1px #646464 dashed;
    padding: 10px 0px;
}
h1 a {
    color: #50BD77;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}


</style>